var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("w-scroll-view", { staticClass: "settings-root" }, [
    _c(
      "div",
      { staticClass: "settings-content" },
      [
        _c("h1", [_vm._v(_vm._s(_vm.$ct("title")))]),
        _c("p", { staticClass: "intro" }, [_vm._v(_vm._s(_vm.$ct("intro")))]),
        _c(
          "w-card",
          { staticClass: "mb" },
          [
            _vm.loaded
              ? _c(
                  "w-card-content",
                  [
                    _c(
                      "w-row",
                      [
                        _c(
                          "w-col",
                          { attrs: { xs: "12" } },
                          [
                            _c("w-checkbox", {
                              attrs: { label: _vm.$ct("enabled") },
                              model: {
                                value: _vm.settings.Enabled,
                                callback: function ($$v) {
                                  _vm.$set(_vm.settings, "Enabled", $$v)
                                },
                                expression: "settings.Enabled",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "w-col",
                          { attrs: { xs: "12", md: "5" } },
                          [
                            _c("w-select", {
                              attrs: {
                                fancy: "",
                                items: _vm.frequencyItems,
                                label: _vm.$ct("frequency"),
                                disabled: !_vm.settings.Enabled,
                              },
                              model: {
                                value: _vm.settings.Frequency,
                                callback: function ($$v) {
                                  _vm.$set(_vm.settings, "Frequency", $$v)
                                },
                                expression: "settings.Frequency",
                              },
                            }),
                            _c("p", { staticClass: "hint" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$ct(
                                    `frequency-hint.${_vm.settings.Frequency}`
                                  )
                                )
                              ),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "w-col",
                          { attrs: { xs: "12", md: "7" } },
                          [
                            _c("w-input", {
                              attrs: {
                                fancy: "",
                                label: _vm.$ct("email"),
                                disabled: !_vm.settings.Enabled,
                              },
                              model: {
                                value: _vm.settings.Email,
                                callback: function ($$v) {
                                  _vm.$set(_vm.settings, "Email", $$v)
                                },
                                expression: "settings.Email",
                              },
                            }),
                            _c("p", { staticClass: "hint" }, [
                              _vm._v(_vm._s(_vm.$ct("email-hint"))),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "w-col",
                          { attrs: { xs: "12" } },
                          [
                            _c("w-checkbox", {
                              attrs: {
                                label: _vm.$ct("notify-on-error"),
                                disabled: !_vm.settings.Enabled,
                              },
                              model: {
                                value: _vm.settings.NotifyOnError,
                                callback: function ($$v) {
                                  _vm.$set(_vm.settings, "NotifyOnError", $$v)
                                },
                                expression: "settings.NotifyOnError",
                              },
                            }),
                            _c("p", { staticClass: "hint" }, [
                              _vm._v(_vm._s(_vm.$ct("notify-on-error-hint"))),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("h3", { staticClass: "section-title" }, [
                      _vm._v(_vm._s(_vm.$ct("dossiers-title"))),
                    ]),
                    !_vm.dossiers.length
                      ? _c("p", { staticClass: "hint" }, [
                          _vm._v(_vm._s(_vm.$ct("dossiers-none"))),
                        ])
                      : [
                          _c("w-radio", {
                            attrs: {
                              name: "dossier-mode",
                              checked: _vm.dossierMode == "all",
                              label: _vm.$ct("dossiers-all"),
                              disabled: !_vm.settings.Enabled,
                            },
                            on: {
                              input: function ($event) {
                                _vm.dossierMode = "all"
                              },
                            },
                          }),
                          _c("w-radio", {
                            attrs: {
                              name: "dossier-mode",
                              checked: _vm.dossierMode == "selection",
                              label: _vm.$ct("dossiers-selection"),
                              disabled: !_vm.settings.Enabled,
                            },
                            on: {
                              input: function ($event) {
                                _vm.dossierMode = "selection"
                              },
                            },
                          }),
                          _vm.dossierMode == "selection"
                            ? _c(
                                "div",
                                { staticClass: "dossier-list" },
                                _vm._l(_vm.dossiers, function (d) {
                                  return _c(
                                    "div",
                                    {
                                      key: d.DossierID,
                                      staticClass: "dossier-item",
                                    },
                                    [
                                      _c("w-checkbox", {
                                        attrs: {
                                          value: _vm.isSelected(d),
                                          label: d.DossierName,
                                          disabled: !_vm.settings.Enabled,
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.toggleDossier(d, $event)
                                          },
                                        },
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "badge",
                                          class: "badge-" + d.IntegrationType,
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.integrationLabel(d))
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                }),
                                0
                              )
                            : _vm._e(),
                        ],
                    _vm.settings.Enabled && _vm.settings.NextSendAt
                      ? _c(
                          "p",
                          { staticClass: "hint status" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$ct("next-send", {
                                    date: _vm.formatDate(
                                      _vm.settings.NextSendAt
                                    ),
                                  })
                                ) +
                                " "
                            ),
                            _vm.settings.LastSentAt
                              ? [
                                  _vm._v(
                                    " · " +
                                      _vm._s(
                                        _vm.$ct("last-sent", {
                                          date: _vm.formatDate(
                                            _vm.settings.LastSentAt
                                          ),
                                        })
                                      )
                                  ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
            _vm.loaded
              ? _c(
                  "w-card-actions",
                  [
                    _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.canTest ? "" : _vm.$ct("test-hint"),
                            expression: "canTest ? '' : $ct('test-hint')",
                          },
                        ],
                        attrs: { disabled: _vm.busy || !_vm.canTest },
                        on: {
                          click: function ($event) {
                            return _vm.sendTest()
                          },
                        },
                      },
                      [
                        _c("w-fa", {
                          staticClass: "mrs",
                          attrs: { icon: "paper-plane" },
                        }),
                        _vm._v(" " + _vm._s(_vm.$ct("send-test")) + " "),
                      ],
                      1
                    ),
                    _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.canTest ? "" : _vm.$ct("test-hint"),
                            expression: "canTest ? '' : $ct('test-hint')",
                          },
                        ],
                        staticClass: "ml",
                        attrs: { disabled: _vm.busy || !_vm.canTest },
                        on: {
                          click: function ($event) {
                            return _vm.sendErrorTest()
                          },
                        },
                      },
                      [
                        _c("w-fa", {
                          staticClass: "mrs",
                          attrs: { icon: "exclamation-triangle" },
                        }),
                        _vm._v(" " + _vm._s(_vm.$ct("send-error-test")) + " "),
                      ],
                      1
                    ),
                    _c("w-spacer"),
                    _c(
                      "w-button",
                      {
                        attrs: { icon: "check", disabled: _vm.busy },
                        on: {
                          click: function ($event) {
                            return _vm.save()
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$ct("save")) + " ")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }